import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { List } from 'immutable';
import MiniBoard from '../Games/MiniBoard';
import { GameGrid, GameTile, TileText } from '../Games/styled';
import { Muted } from '../Controls';
import { Panel, PanelTitle } from '../Page';
import { shortWhen } from '../dates';
import Avatar from '../Avatar';
import { getWatchList } from './actions';

/** What a game to watch is, in words: "Ash vs Misty". */
const players = (game) => (game.get('users') || List()).map(user => user.get('name')).join(' vs ');

/** Other people's games to watch, most recently played first, on the games page. */
const WatchList = () => {
  const dispatch = useDispatch();
  const games = useSelector((state) => state.watch.get('list'));

  useEffect(() => {
    dispatch(getWatchList());
  }, [dispatch]);

  return (
    <Panel>
      <PanelTitle>Watch a game</PanelTitle>
      {!games && <Muted>Loading…</Muted>}
      {games && !games.size && <Muted>Nobody else is playing right now.</Muted>}
      {games && games.size > 0 && (
        <GameGrid>
          {games.map(game => (
            <GameTile key={game.get('id')}>
              <Link to={`/watch/${game.get('id')}`}>
                {/* The first player at the bottom, as on the watch page. */}
                <MiniBoard game={game} userId={game.getIn(['users', 0, 'id'])} />
                <TileText>
                  <strong>
                    {(game.get('users') || List()).map(user => <Avatar key={user.get('id')} user={user} size={20} game={game.get('id')} />)} {players(game)}
                  </strong>
                  <Muted as="span">{game.get('ended_at') ? 'Finished' : 'Playing'} · {shortWhen(game.get('updated_at'))}</Muted>
                </TileText>
              </Link>
            </GameTile>
          ))}
        </GameGrid>
      )}
    </Panel>
  );
};

export default WatchList;
